






















import { Component, Vue } from "vue-property-decorator";
import { OrganisationModel, PrivatePersonModel } from "../models";
import { namespace } from "vuex-class";

import RelationData from "modules/relationprofile/components/RelationData.vue";
import ContactsTable from "modules/relationprofile/components/ContactsTable.vue";
import AddressBlock from "modules/relationprofile/components/AddressBlock.vue";
import RelationArchive from "modules/relationprofile/components/RelationArchive.vue";
import { getProfile } from "shared/api";
import { RelationType } from "shared/store/auth/types";
import { TComponent } from "../../../shared/bootstrap";
import { getFrontendConfig } from "../api";

const opStore = namespace("relationprofile");
const snackStore = namespace("snackbar");

@Component({
  components: { RelationData, ContactsTable, AddressBlock, RelationArchive },
})
export default class MyData extends Vue {
  @opStore.Getter currentOrganisation!: OrganisationModel;
  @opStore.Getter currentPrivatePerson!: PrivatePersonModel;

  @opStore.Action fetchCurrentOrganisation!: () => Promise<void>;
  @opStore.Action fetchCurrentPrivatePerson!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  private showArchive = false;
  private showArchiveProjects = false;
  private RelationType: typeof RelationType = RelationType;
  private currentType = "";
  private contactButtonComponent: TComponent = () =>
    import("../components/ContactButton.vue");

  get showContactButton(): boolean {
    return this.$route.meta && this.$route.meta.contact;
  }

  get currentRelation(): OrganisationModel | PrivatePersonModel {
    return this.currentType === RelationType.private
      ? this.currentPrivatePerson
      : this.currentOrganisation;
  }

  async mounted(): Promise<void> {
    try {
      const profile = await getProfile();
      this.currentType = profile.relation_type;
      if (profile.relation_type === RelationType.contact) {
        this.fetchCurrentOrganisation();
      } else {
        this.fetchCurrentPrivatePerson();
      }

      const c = await getFrontendConfig();
      this.showArchive = c.archive_enable;
      this.showArchiveProjects = c.archive_show_project_files;
    } catch (e) {
      this.defaultError();
    }
  }
}
